import BaseMode    from './BaseMode'
import CreateMode  from './CreateMode'
import RewriteMode from './RewriteMode'

/**
 * Реестр доступных режимов. Ключ — код режима (значение `$route.query.type`).
 */
const MODES = {
    [CreateMode.code]:  CreateMode,
    [RewriteMode.code]: RewriteMode,
}

/**
 * Возвращает класс режима по его коду. При неизвестном/пустом коде —
 * дефолтное оформление (`CreateMode`).
 *
 * @param {string|null|undefined} type
 * @returns {typeof BaseMode}
 */
export function resolveMode(type) {
    return MODES[type] || CreateMode
}

export { BaseMode, CreateMode, RewriteMode }
